import React from "react";
import {
  ModalContainerStyle,
  ModalContentStyle,
  BtnModalVoltarStyle,
  BtnModalSeguirStyle,
} from "./style";

function ModalConfirmacao({
  visivel,
  titulo,
  conteudo,
  onClickConfirma,
  onClickRecusa,
  confirmaLabel = "Continuar",
  recusaLabel = "Cancelar",
}) {
  return (
    <>
      <div className={visivel === true ? ` modal is-active` : `modal`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <ModalContainerStyle>
            <ModalContentStyle>
              <div className="attention">
                <ion-icon name="alert-circle"></ion-icon>
              </div>

              <p>{titulo}</p>
              <p>{conteudo}</p>

              <BtnModalSeguirStyle onClick={onClickConfirma}>{confirmaLabel}</BtnModalSeguirStyle>

              <BtnModalVoltarStyle onClick={onClickRecusa}>{recusaLabel}</BtnModalVoltarStyle>
            </ModalContentStyle>
          </ModalContainerStyle>
        </div>
      </div>
    </>
  );
}

export default ModalConfirmacao;
